import { useState } from 'react';

import { useMsal } from '@azure/msal-react';

import { Button } from '@frontend/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@frontend/components/ui/card';
import { TokenExchangePage } from '@frontend/features/auth/components/TokenExchangePage';
import { loginRequest } from '@frontend/features/auth/config/authConfig';
import { isLocalhost } from '@frontend/features/auth/util/util.auth.isLocalhost';

// Separate component for MSAL login to avoid conditional hook calls
function MsalLoginPage() {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    if (isLoading) return;

    setIsLoading(true);
    setError(null);

    try {
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      console.error('Login failed:', err);
      setError('Login failed. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <Card className="w-[350px]">
        <CardHeader>
          <CardTitle>Welcome to K2</CardTitle>
          <CardDescription>
            Sign in with your Office 365 account to continue
          </CardDescription>
        </CardHeader>
        <CardContent>
          {error && <div className="text-red-500 mb-4">{error}</div>}
          <Button onClick={handleLogin} className="w-full" disabled={isLoading}>
            {isLoading ? 'Signing in...' : 'Sign in with Microsoft'}
          </Button>
        </CardContent>
        <CardFooter className="text-xs text-center text-gray-500">
          Access is restricted to authorized users only.
        </CardFooter>
      </Card>
    </div>
  );
}

export function LoginPage() {
  // On localhost, show token exchange page instead
  if (isLocalhost()) {
    return <TokenExchangePage />;
  }

  // On dev/production, show MSAL login
  return <MsalLoginPage />;
}
